import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  GetAdminEmployeeActiveList,
  AdminHodEmployeeActiveList,
  AdminProfile,
} from "../../Repository/Api";
import { Link } from "react-router-dom";
import { errorMsg } from "../Toastify";

const AdminEmployeeList = () => {
  const { first_name, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const [employeeList, setEmployeeList] = useState({});
  const [hodEmployeeList, setHodEmployeeList] = useState({});

  useEffect(() => {
    getEmployeeList();
    getHodEmployeeList();
  },[]);

  const [active, setActive] = useState(0);
  const links = ["Staff", "Hod"];
  const showSelected = (index) => {
    setActive(index);
  };
  const [dummyleaveList, setdummyLeaveList] = useState([]);

  const [searchText, setSearchText] = useState("");
  

  const SearchfilteredData = dummyleaveList?.filter((item) =>
    Object.values(item).some((value) =>
      value?.toString().toLowerCase().includes(searchText.toLowerCase())
    )
  );
  useEffect(() => {
    if (searchText) {
      setEmployeeList(SearchfilteredData);
    } else {
      setEmployeeList(dummyleaveList);
    }
  }, [searchText, dummyleaveList]);
  const getEmployeeList = async () => {
    const response = await GetAdminEmployeeActiveList(token);
    if (response && response.statusCode === 200) {
      // setEmployeeList(response?.data?.employee_details);
      setdummyLeaveList(
        response?.data?.employee_details
      );
    } else {
      errorMsg(response.message);
    }
  };
  // hod 

  const [dummyleaveListhod, setdummyLeaveListHod] = useState([]);

  const [searchTextHod, setSearchTextHod] = useState("");

  const SearchfilteredDataHod = dummyleaveListhod?.filter((item) =>
    Object.values(item).some((value) =>
      value?.toString().toLowerCase().includes(searchTextHod.toLowerCase())
    )
  );

  useEffect(() => {
    if (searchTextHod) {
      setHodEmployeeList(SearchfilteredDataHod);
    } else {
      setHodEmployeeList(dummyleaveListhod);
    }
  }, [searchTextHod, dummyleaveListhod]);
  const getHodEmployeeList = async () => {
    const response = await AdminHodEmployeeActiveList(token);
    if (response && response.statusCode === 200) {
      // setHodEmployeeList(response?.data?.employee_details);
      setdummyLeaveListHod(
        response?.data?.employee_details
      );
    } else {
      errorMsg(response.message);
    }
  };

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">{first_name}</h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <div className="row">
                  <div className="col-lg-3">
                    <h6 className="labeltitle">Employee List</h6>
                  </div>
                  <div className="col-lg-4">
                    <ul className="searchtopflex">
                      {links.map((link, index) => {
                        return (
                          <li
                            onClick={() => showSelected(index)}
                            key={link}
                            className={
                              active === index
                                ? "agenttextactive"
                                : "agenttextinactive"
                            }
                          >
                            {link}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                  {/* <div className="col-lg-5 my-auto">
                    <div className="tablealign">
                      <img className="tableicon" src={Download} alt="Dasb" />
                      <img className="tableicon" src={Print} alt="Dasb" />
                    </div>
                  </div> */}
                </div>
                <div className="scroll-table">
                  {active === 0 && (
                    <>
                      {" "}
                      <div className="row justify-content-end mt-3">
                        <div className="col-lg-4">
                          <div class="input-group flex-nowrap">
                            <span class="input-group-text" id="addon-wrapping">
                              <span class="material-symbols-outlined search-input-icon">
                                search
                              </span>
                            </span>
                            <input
                              type="text"
                              class="form-control search-table-data"
                              placeholder="Search"
                              aria-describedby="addon-wrapping"
                              name="search"
                              value={searchText}
                              onChange={(e) => setSearchText(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                      <table className="table table-hover mt-5">
                        <thead>
                          <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Designation</th>
                            <th scope="col">Department</th>
                            <th scope="col">Employee ID</th>
                            <th scope="col">Email Id</th>
                            <th scope="col">Phone No</th>
                            <th scope="col">More Info</th>
                          </tr>
                        </thead>
                        <tbody>
                          {employeeList?.length > 0 ? (
                            employeeList &&
                            employeeList?.map((employee, index) => (
                              <tr key={index}>
                                <td>
                                  {employee?.first_name
                                    ? employee?.first_name
                                    : "-"}
                                </td>
                                <td>
                                  {employee?.designation
                                    ? employee?.designation
                                    : "-"}
                                </td>
                                <td>
                                  {employee?.department
                                    ? employee?.department
                                    : "-"}
                                </td>
                                <td>
                                  {employee?.employee_id
                                    ? employee?.employee_id
                                    : "-"}
                                </td>
                                <td>
                                  {employee?.email_id
                                    ? employee?.email_id
                                    : "-"}
                                </td>
                                <td>
                                  {employee?.phone_number
                                    ? employee?.phone_number
                                    : "-"}
                                </td>

                                <td className="viewoption">
                                  <Link
                                    to={`/app/admin/AdminEmployeeSpecificView/${employee?.id}`}
                                  >
                                    View Details
                                  </Link>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <div className="centertext"> No Data Found</div>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </>
                  )}
                  {active === 1 && (
                    <>  <div className="row justify-content-end mt-3">
                      <div className="col-lg-4">
                        <div class="input-group flex-nowrap">
                          <span class="input-group-text" id="addon-wrapping">
                            <span class="material-symbols-outlined search-input-icon">
                              search
                            </span>
                          </span>
                          <input
                            type="text"
                            class="form-control search-table-data"
                            placeholder="Search"
                            aria-describedby="addon-wrapping"
                            name="search"
                            value={searchTextHod}
                            onChange={(e) => setSearchTextHod(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                      <table className="table table-hover mt-5">
                        <thead>
                          <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Department</th>
                            <th scope="col">Email Id</th>
                            <th scope="col">Phone No</th>
                            <th scope="col">More Info</th>
                          </tr>
                        </thead>
                        <tbody>
                          {hodEmployeeList?.length > 0 ? (
                            hodEmployeeList &&
                            hodEmployeeList?.map((employee, index) => (
                              <tr key={index}>
                                <td>
                                  {employee?.first_name
                                    ? employee?.first_name
                                    : "-"}
                                </td>
                                <td>
                                  {employee?.department
                                    ? employee?.department
                                    : "-"}
                                </td>
                                <td>
                                  {employee?.email_id ? employee?.email_id : "-"}
                                </td>
                                <td>
                                  {employee?.phone_number
                                    ? employee?.phone_number
                                    : "-"}
                                </td>

                                <td className="viewoption">
                                  <Link
                                    to={`/app/admin/AdminEmployeeSpecificView/${employee?.id}`}
                                  >
                                    View Details
                                  </Link>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <div className="centertext"> No Data Found</div>
                            </tr>
                          )}
                        </tbody>
                      </table></>

                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AdminEmployeeList;
